/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import template from "templates/rubric/range_picker_scoring_key.hbs";

import { View } from "backbone.marionette";

export default class RangePickerScoringKeyView extends View.extend({
  template,
  className: "range-post"
}) {
  initialize(options) {
    this.vent = options.vent;
    this.model = options.model;

    this.listenTo(this.collection, "change:ranges change", () => {
      return this.render();
    });
  }
}
